import React from 'react';
import { Box, Typography, Paper, useTheme } from '@mui/material';
import { Security as SecurityIcon } from '@mui/icons-material';

const PrivacyNotice = ({ title, children, icon: CustomIcon, sx = {} }) => {
  const theme = useTheme();
  const IconComponent = CustomIcon || SecurityIcon;
  
  // Colors for light and dark themes
  const colors = {
    light: {
      bg: '#e8eaf6',
      border: '#c5cae9',
      icon: '#3949ab',
      title: '#283593',
      text: '#1a237e'
    },
    dark: {
      bg: 'rgba(63, 81, 181, 0.15)',
      border: '#5c6bc0',
      icon: '#9fa8da',
      title: '#c5cae9',
      text: '#e8eaf6'
    }
  };
  
  const currentColors = theme.palette.mode === 'dark' ? colors.dark : colors.light;
  
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.5,
        mb: 3,
        borderRadius: 2,
        backgroundColor: currentColors.bg,
        border: '1px solid',
        borderColor: currentColors.border,
        boxShadow: theme.palette.mode === 'dark' ? '0 4px 20px rgba(0,0,0,0.3)' : 'none',
        transition: 'all 0.2s ease',
        '&:hover': {
          boxShadow: theme.palette.mode === 'dark' ? '0 6px 25px rgba(0,0,0,0.4)' : '0 4px 15px rgba(0,0,0,0.1)',
        },
        ...sx
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
        <IconComponent 
          sx={{ 
            mr: 2, 
            mt: 0.3,
            color: currentColors.icon,
            fontSize: '1.5rem',
            filter: theme.palette.mode === 'dark' ? 'drop-shadow(0 0 2px rgba(159, 168, 218, 0.5))' : 'none'
          }} 
        />
        <Box sx={{ flex: 1 }}>
          {title && (
            <Typography 
              variant="h6" 
              component="div"
              sx={{ 
                fontWeight: 'bold', 
                color: currentColors.title,
                mb: 1
              }}
            >
              {title}
            </Typography>
          )}
          <Typography 
            variant="body1" 
            component="div"
            sx={{ color: currentColors.text }}
          >
            {children}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default PrivacyNotice;